<template>
  <div>
    <div v-if="!isTagInputVisible" style="float:left">
      <el-tag
        v-for="(tag,index) in curTags"
        :key="index"
        closable
        :disable-transitions="false"
        style="margin-right:5px"
        @close="handleClose(tag)"
      >
        {{ tag }}
      </el-tag>
    </div>
    <div>

      <el-select
        v-if="isTagInputVisible"
        :ref="'saveTagInput-'+contactId"
        v-model="curTags"
        multiple
        filterable
        allow-create
        default-first-option
        placeholder="请选择标签"
        @change="handleTagChange()"
        @focus="handleTagFocus()"
      >
        <el-option
          v-for="item in tagOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button v-else style="float:left" class="button-new-tag" type="primary" size="mini" @click="showInput()">+</el-button>
    </div>
  </div>
</template>
<script>
import pathReq from '@/api/pathlist'
import KxjCom from '@/utils/kxjcom'
import { arrayRemove } from '@/utils'
export default {
  props: {
    // 联系人ID
    contactId: { type: Number, default: null },
    // 默认标签
    defTags: { type: String, default: '' }
  },
  data() {
    return {
      isTagInputVisible: false,
      // 标签
      inputVisible: false,
      inputValue: '',
      tagOptions: [],
      curTags: [] // 当前标签
    }
  },
  watch: {
    defTags: {
      handler() {
        if (!this.defTags) {
          this.curTags = []
        } else {
          this.curTags = this.defTags.split(',')
        }
      },
      deep: true
    }
  },
  activated() {
    const that = this
    const loading = this.$loading(KxjCom.loadOptions)

    pathReq.getList('/api/services/app/Contact/GetAllFriendTags')
      .then(res => {
        that.tagOptions = []
        res.data.result.forEach(element => {
          that.tagOptions.push({
            value: element,
            label: element
          })
        })
      }).then(_ => {
        loading.close()
      })
  },
  methods: {
    /** 取得标签 */
    getTags() {
      if (!this.curTags) {
        return []
      } else {
        return this.curTags.split(',')
      }
    },
    /** 删除标签 */
    handleClose(tag) {
      const that = this
      const path = '/api/services/app/Contact/DelTag'
      pathReq
        .postForm(path, {
          id: that.contactId,
          newTagVal: tag
        }).then(_ => {
          arrayRemove(that.curTags, tag)
        })
    },
    /** 展示显示标签输入框 */
    showInput() {
      this.isTagInputVisible = true
      const that = this
      var refKey = 'saveTagInput-' + this.contactId
      this.$nextTick(_ => {
        that.$refs[refKey].$refs.input.focus()
      })
    },

    /** 修改标签 */
    handleTagChange() {
      const that = this
      this.curTags.forEach(ele => {
        var exist = that.tagOptions.find(i => i.value === ele)
        if (!exist) {
          that.tagOptions.push({
            value: ele,
            label: ele
          })
        }
      })

      const path = '/api/services/app/Contact/ResetTag'
      var data = {
        Id: this.contactId,
        UserName2: this.curTags.join()
      }
      pathReq.postForm(path, data).then(_ => {
        that.isTagInputVisible = false
      })
    },
    handleTagFocus() {
      const that = this
      var refKey = 'saveTagInput-' + this.contactId
      this.$refs[refKey].$refs.input.blur = () => {
        that.isTagInputVisible = false
      }
    }

  }
}
</script>
